export const env = {
    api_base_url: process.env.VUE_APP_API_BASE_URL,
    resources_base_url: process.env.VUE_APP_RESOURCES_BASE_URL,
    base_url: process.env.BASE_URL,
    flag_env: process.env.VUE_APP_FLAG_ENV,
    paypal_client_id: process.env.VUE_APP_PAYPAL_CLIENT_ID,
}

export default {
  data: function () {
    return { ...env };
  },
};
